var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"png","imageName":"YouDecide","routePath":"youdecide","company":"YouDecide"}})
}
var staticRenderFns = []

export { render, staticRenderFns }